import {
  indexSetObjectsForUI,
  PublicUserProfile,
  PublicWorkout,
  setObjectToUIFacingSetIndicator,
} from 'hevy-shared';
import { makeAutoObservable } from 'mobx';
import API from 'utils/API';
import {
  calculatePublicWorkoutStats,
  calculateSecondColumnHeader,
  calculateSetValue,
} from './utils';
import { ExerciseProps } from './components/types';
import { sendEvent } from 'utils/events';
import { copyToClipboard } from 'utils/clipboard';
import toast from 'react-hot-toast';
import { IBAI_USERNAME } from 'utils/vip';
import { stores } from 'state/stores';

export class WorkoutDetailPublicViewModel {
  workout: PublicWorkout;
  userProfile: PublicUserProfile | undefined;

  constructor(workout: PublicWorkout) {
    this.workout = workout;

    makeAutoObservable(this);
  }

  refreshContent = async () => {
    const { username } = this.workout;

    const result = await API.getPublicUserProfile(username);
    this.userProfile = result.data;
  };

  onCopyLinkPress = () => {
    sendEvent('workoutDetail_copyLink', { workoutId: this.workout.id });
    copyToClipboard(window.location.href);
    toast.success('Copied to clipboard');
  };

  get showExerciseDetails() {
    return (
      this.workout.username !== IBAI_USERNAME || this.workout.username === stores.account.username
    );
  }

  get stats() {
    return calculatePublicWorkoutStats(this.workout);
  }

  get exercises(): ExerciseProps[] {
    const { weight_unit, distance_unit } = this.workout;

    return this.workout.exercises.map(e => {
      const indexedSets = indexSetObjectsForUI(e.sets);

      return {
        key: e.id,
        image: e.thumbnail_url ?? undefined,
        title: e.title,
        supersetId: e.superset_id ?? undefined,
        notes: e.notes,
        secondColumnHeader: calculateSecondColumnHeader(e),
        sets: e.sets.map((s, setIndex) => ({
          key: `${s.id}`,
          indicator: setObjectToUIFacingSetIndicator(indexedSets[setIndex]),
          reps: s.reps,
          value: calculateSetValue(e, s, {
            weightUnit: weight_unit,
            distanceUnitShort: distance_unit === 'kilometers' ? 'km' : 'mi',
          }),
          rpe: s.rpe,
          prs: s.prs,
        })),
      };
    });
  }
}
